import { getCitiesError, getCitiesLoading, getCitiesSuccess, getCountriesError, getCountriesLoading, getCountriesSuccess, getStatesError, getStatesLoading, getStatesSuccess } from './actions';
import api from '../api';
import { toast } from 'react-toastify';

const getCountriesAction = (postData) => {
    return async (dispatch) => {
        try {
            // Start the loading state
            dispatch(getCountriesLoading());

            // Perform the asynchronous operation (e.g., API call)
            const response = await api.post('services/ord_services_v1.php', { ...postData, action: 'get_country' });
            const data = response.data;

            // Dispatch success action with the received data
            dispatch(getCountriesSuccess(data));
            if (data?.success) {
                // toast.success(data?.message);
            }
            if (data?.error) {
                toast.error(data?.error);
            }
        } catch (error) {
            // Dispatch error action if an error occurs
            dispatch(getCountriesError(error.message));
            toast.error(error?.response?.data?.message);
        }
    };
};

const getStatesAction = (postData) => {
    return async (dispatch) => {
        try {
            // Start the loading state
            dispatch(getStatesLoading());

            // Perform the asynchronous operation (e.g., API call)
            const response = await api.post('services/ord_services_v1.php', { ...postData, action: 'get_state' });
            const data = response.data;

            // Dispatch success action with the received data
            dispatch(getStatesSuccess(data));
            if (data?.success) {
                // toast.success(data?.message);
            }
            if (data?.error) {
                toast.error(data?.error);
            }
        } catch (error) {
            // Dispatch error action if an error occurs
            dispatch(getStatesError(error.message));
            toast.error(error?.response?.data?.message);
        }
    };
};

const getCitiesAction = (postData) => {
    return async (dispatch) => {
        try {
            // Start the loading state
            dispatch(getCitiesLoading());

            // Perform the asynchronous operation (e.g., API call)
            const response = await api.post('services/ord_services_v1.php', { ...postData, action: 'get_city' });
            const data = response.data;

            // Dispatch success action with the received data
            dispatch(getCitiesSuccess(data));
            if (data?.success) {
                // toast.success(data?.message);
            }
            if (data?.error) {
                toast.error(data?.error);
            }
        } catch (error) {
            // Dispatch error action if an error occurs
            dispatch(getCitiesError(error.message));
            toast.error(error?.response?.data?.message);
        }
    };
};

export {
    getCountriesAction,
    getStatesAction,
    getCitiesAction
};
